var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({attrs:{"src":require("../assets/images/icons/logo.svg"),"alt":""}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }